import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoLiveService {

  private goLiveDateSource = new BehaviorSubject<Date | null>(null);
  goLiveDate$ = this.goLiveDateSource.asObservable();

  setGoLiveDate(date: Date) {
    this.goLiveDateSource.next(date);
  }

  isBeforeGoLive(date: Date | null): boolean {
    if (!date) return false;
    return new Date() < date;
  }
}
